import { AccountingSubType } from "@entities/accounting/lib/constants";

export const BILLING_TYPES: AccountingSubType[] = [
  AccountingSubType.invoice,
  AccountingSubType.debitNote,
  AccountingSubType.creditNote,
];
